export default __webpack_public_path__ + "static/media/10.f20f1a15.jpg";